const sleep = (ms: number) =>
  new Promise<void>(resolve => {
    setTimeout(resolve, ms);
  });

export type RetryOptions = {
  maxAttempts?: number;
  delayMs?: number;
};

export async function withRetryOn504<T>(
  operation: () => Promise<T>,
  {maxAttempts = 3, delayMs = 15_000}: RetryOptions = {},
): Promise<T> {
  for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
    try {
      return await operation();
    } catch (err) {
      const typed = err as {status?: number; problem?: string} | undefined;
      const isGatewayTimeout =
        typed?.status === 504 || typed?.problem === "NETWORK_ERROR";
      if (!isGatewayTimeout || attempt === maxAttempts) {
        throw err;
      }
      await sleep(delayMs);
    }
  }
  // Unreachable: loop body always returns or throws.
  throw new Error("withRetryOn504: unreachable");
}
